<template>
  <div>
    <highstock ref="seriesChart" :options="options"></highstock>
  </div>
</template>

<script>
// import moment from 'moment-timezone'

export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    scale: {
      type: String
    },
    series: {
      type: Array
    },
    labels: {
      type: Array
    },
    height: {
      type: Number,
      default: 300
    }
  },
  watch: {
    series () {
      this.options.series = this.series
    }
  },
  data () {
    return {
      options: {
        chart: {
          type: 'line',
          height: this.height,
          zoomType: 'x'
        },
        // annotations: [{
        //   labels: [{
        //     point: {
        //       xAxis: 0,
        //       yAxis: 0,
        //       x: 1525686300000,
        //       y: 189.4
        //     },
        //     text: 'Temp. Sensor Malfunction'
        //   }]
        // }],
        title: {
          align: 'left',
          text: this.title,
          floating: false,
          y: 15,
          style: {
            color: '#333',
            fontSize: '14px',
            fontWeight: '400'
          }
        },
        subtitle: {
          text: '',
          style: {
            display: 'none'
          }
        },
        time: {
          timezone: 'America/New_York',
          useUTC: false
        },
        rangeSelector: {
          allButtonsEnabled: false,
          buttons: [ {
            type: 'day',
            count: 1,
            text: '1d'
          }, {
            type: 'day',
            count: 7,
            text: '1w'
          }, {
            type: 'month',
            count: 1,
            text: '1m'
          }, {
            type: 'month',
            count: 3,
            text: '3m'
          }, {
            type: 'year',
            count: 1,
            text: '1y'
          }, {
            type: 'all',
            text: 'All'
          }]
        },
        /*
        xAxis: {
          categories: this.labels,
          labels: {
            formatter: function () {
              return this.value // return moment(this.value).format('lll')
            }
          }
        },
        */
        yAxis: {
          title: {
            text: this.scale
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true
            }
          }
        },
        tooltip: {
          split: false,
          shared: true,
          hideDelay: 500,
          followPointer: true,
          shadow: true,
          animation: false,
          valueSuffix: '',
          pointFormat: '{series.name}: <b>{point.y:,.3f}</b><br/>',
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0
        },
        series: this.series,
        boost: {
          enabled: true
        }
      }
    }
  }
}
</script>

<style scoped></style>
